import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CertificateApprovalPageLayer from "../components/CertificateApproval";


const CertificateApprovalPage = () => {
    return (
        <>

            {/* MasterLayout */}
            <MasterLayout>

                {/* Breadcrumb */}
                <Breadcrumb title="Certificate Approval" header="Certificate Approval" />

                {/* CoursePageLayer */}
                <CertificateApprovalPageLayer />


            </MasterLayout>

        </>
    );
};

export default CertificateApprovalPage;
